import { Character } from "./character.js";
import { Commander } from "./commander.js";
import { Menu_manager } from "./menu_manager_2.js";

export let commander = new Commander();

export let character = new Character(commander);
commander.character = character;

export let menu_manager = new Menu_manager(character, commander);
commander.menu_manager = menu_manager;

